import { render } from "./ExaminableIssuesDisplay.vue?vue&type=template&id=a7b44044&scoped=true"
import script from "./ExaminableIssuesDisplay.vue?vue&type=script&lang=js"
export * from "./ExaminableIssuesDisplay.vue?vue&type=script&lang=js"

import "./ExaminableIssuesDisplay.vue?vue&type=style&index=0&id=a7b44044&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b44044"]])

export default __exports__